var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenezuela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4124 23.3758C31.4296 21.2723 32 18.9125 32 16.4193C32 13.9262 31.4296 11.5663 30.4124 9.46285L16 8.07153L1.58763 9.46285C0.570438 11.5663 0 13.9262 0 16.4193C0 18.9125 0.570438 21.2723 1.58763 23.3758L16 24.7672L30.4124 23.3758Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 32.4192C22.3431 32.4192 27.8242 28.7276 30.4122 23.3757H1.5874C4.1754 28.7276 9.6564 32.4192 15.9998 32.4192Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7105 19.5601L26.8654 20.2205L27.2322 21.228L26.343 20.6285L25.4979 21.2887L25.7934 20.2578L24.9043 19.658L25.9761 19.6207L26.2719 18.5897L26.6387 19.5975L27.7105 19.5601Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5464 15.812L24.9782 16.7216L25.6677 17.543L24.627 17.2838L24.0586 18.1932L23.9837 17.1233L22.9431 16.8638L23.9376 16.462L23.8629 15.3921L24.5522 16.2138L25.5464 15.812Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2312 13.0299L22.0083 14.079L22.937 14.6152L21.8705 14.7277L21.6475 15.7764L21.2112 14.7968L20.1445 14.9087L20.9417 14.1911L20.5055 13.2115L21.4342 13.7476L22.2312 13.0299Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1639 11.5495L18.3133 12.6115L19.3694 12.7977L18.4055 13.268L18.5548 14.33L17.8098 13.5585L16.8457 14.0287L17.3493 13.0816L16.6042 12.3102L17.6605 12.4964L18.1639 11.5495Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8363 11.5495L14.3399 12.4964L15.3959 12.3101L14.651 13.0818L15.1544 14.0288L14.1905 13.5585L13.4454 14.3298L13.5948 13.268L12.6309 12.7979L13.687 12.6115L13.8363 11.5495Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76941 13.0299L10.5665 13.7476L11.4951 13.2115L11.059 14.1915L11.856 14.909L10.7894 14.7968L10.353 15.7764L10.1303 14.7275L9.06372 14.6155L9.99247 14.0791L9.76941 13.0299Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45346 15.8121L7.44802 16.2138L8.13715 15.3923L8.06258 16.4624L9.05683 16.8642L8.01627 17.1235L7.94133 18.1932L7.37321 17.2839L6.33252 17.5432L7.02189 16.7217L6.45346 15.8121Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28979 19.5601L5.36179 19.5975L5.72842 18.5899L6.02436 19.6209L7.09604 19.6583L6.20692 20.2581L6.50242 21.2889L5.65742 20.6287L4.76823 21.2282L5.13504 20.2205L4.28979 19.5601Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4122 9.46245C27.8242 4.11051 22.3431 0.418945 15.9998 0.418945C9.6564 0.418945 4.1754 4.11051 1.5874 9.46245H30.4122Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenezuela);
export default __webpack_public_path__ + "static/media/venezuela.9a0f10a7.svg";
export { ForwardRef as ReactComponent };